import { useState } from "react";

interface FAQItem {
  q: string;
  a: string;
}

interface SectionFAQProps {
  faqs: FAQItem[];
  title?: string;
}

export default function SectionFAQ({ faqs, title = "Frequently Asked Questions" }: SectionFAQProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-white py-24" id="faq">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-3">
            Voice Search Optimized
          </span>
          <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-[#0A1628] mb-4">
            {title}
          </h2>
          <div className="w-16 h-0.5 bg-[#C9A961] mx-auto" />
        </div>

        <div className="flex flex-col gap-2.5">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIdx === i
                  ? "border-[#C9A961]/40 bg-[#FEFDFB]"
                  : "border-slate-200 bg-white"
              }`}
            >
              <button
                className="w-full flex items-start justify-between px-6 py-4 text-left cursor-pointer gap-4"
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
              >
                <span className="font-inter font-semibold text-[#0A1628] text-sm leading-relaxed">
                  {faq.q}
                </span>
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 transition-all duration-200 ${
                    openIdx === i ? "bg-[#0A1628]" : "bg-[#0A1628]/6"
                  }`}
                >
                  <i
                    className={`text-xs transition-all ${
                      openIdx === i
                        ? "ri-subtract-line text-[#C9A961]"
                        : "ri-add-line text-[#0A1628]"
                    }`}
                  />
                </span>
              </button>
              {openIdx === i && (
                <div className="px-6 pb-5 border-t border-slate-100">
                  <p className="text-slate-600 font-inter text-sm leading-relaxed pt-4">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
